document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.hero .button');
  const target = document.querySelector('section.buchung');
  const toggle = document.querySelector('.hero .toggle');
  const nav = document.querySelector('.hero nav');
  const icon = document.querySelector('.hero .toggle .material');

  toggle?.addEventListener('click', () => {
    const isOpen = nav?.classList.toggle('open');
    if (icon) icon.textContent = isOpen ? 'close' : 'drag_handle';
  });

  document.addEventListener('click', (event) => {
    if (nav?.contains(event.target) || toggle?.contains(event.target)) return;
    nav?.classList.remove('open');
    if (icon) icon.textContent = 'drag_handle';
  });

  if (!button || !target) return;

  button.addEventListener('click', (event) => {
    event.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });

});
